'use client';

import type { FC } from 'react';

import type { Article, ArticlePreview } from '@hyex/dxp/types/blog/Article';

import CategoryArticleBase from '@hyex/modules/shared/Article/views/category-article';

type PropTypes = {
  items: Article[] | ArticlePreview[];
  showTopArticle?: boolean;
  topArticle?: Article | ArticlePreview;

  articlePath?: string;
  categoryPath?: string;
  prefetchLinks?: boolean;
};

const CategoryArticleGrid: FC<PropTypes> = ({
  items,
  topArticle,
  showTopArticle,
  articlePath,
  categoryPath,
  prefetchLinks = true,
}) => {
  showTopArticle = false;

  return (
    <>
      <div className="category-article-wrapper">
        {showTopArticle && topArticle && (
          <CategoryArticleBase
            article={topArticle}
            className={'category-article top'}
            withCategory={false}
            categoryPath={categoryPath}
            articlePath={articlePath}
            prefetchLinks={prefetchLinks}
          />
        )}

        <div className="container">
          {items && items.length > 0 && (
            <div className="category-article-list">
              {items.map((article, index) => {
                return (
                  <CategoryArticleBase
                    key={article.id}
                    article={article}
                    className={'category-article '}
                    withCategory={true}
                    categoryPath={categoryPath}
                    articlePath={articlePath}
                    prefetchLinks={prefetchLinks}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CategoryArticleGrid;
